/**
 * App Review lockdown — T49.R (Build 79).
 *
 * Builds 73–78 kept getting rejected because the iOS bundle kept
 * leaking App-Review-risky surfaces (REFER A FRIEND, Invite modal,
 * visible Connection Diagnostics row). The root cause in every
 * cycle was "the source was fine but the Mac's frontend/build/ was
 * stale" or "the .env on the Mac didn't carry the off-flag".
 *
 * Both classes of bug share a single root: the gate was *external*
 * to the codebase (env vars + build hygiene). When that external
 * state drifts, the .ipa leaks.
 *
 * T49.R closes the gap with a SOURCE-LEVEL hardcoded constant.
 * `APP_REVIEW_LOCKDOWN = true` is committed to the repo. Every
 * App-Review-risky surface checks this constant directly. There is
 * NO way for a stale build directory, a missing env var, or a
 * forgotten flag flip to ship a non-lockdown bundle: the lockdown
 * is the source itself.
 *
 * Post-approval workflow:
 *   1. Apple approves the lockdown build.
 *   2. Flip `APP_REVIEW_LOCKDOWN` to `false` in this file in a
 *      single commit (a one-character diff: `true` → `false`).
 *   3. `yarn build` → archive → upload Build 80+ with the full
 *      referral + diagnostics surface restored.
 *
 * The `LOCKDOWN_BUILD_MARKER` constant below is anchored into the
 * production JS bundle via `src/index.js` (window assignment, which
 * is a side effect webpack cannot tree-shake). `release-gate.sh`
 * greps the built bundle for `__TIPLINGO_LOCKDOWN=ACTIVE__` and
 * REFUSES to let the user archive otherwise — so even a stale
 * frontend/build/ directory from a pre-T49.R commit is blocked at
 * the gate, not by Apple.
 */

// HARDCODED. Do not derive from env, do not template, do not
// compute. The expression below must constant-fold to the literal
// boolean `true` so webpack can dead-code-eliminate every
// `!APP_REVIEW_LOCKDOWN && (...)` block to its falsy branch.
export const APP_REVIEW_LOCKDOWN = true;

// Constant-folded by webpack to one of two string literals so
// release-gate.sh can grep the production bundle reliably. The
// `?:` (not a function call) keeps the resolution at build time
// rather than runtime — same pattern that finally worked for
// REFERRAL_BUILD_MARKER in T49.Q.
export const LOCKDOWN_BUILD_MARKER = APP_REVIEW_LOCKDOWN
  ? "__TIPLINGO_LOCKDOWN=ACTIVE__"
  : "__TIPLINGO_LOCKDOWN=OFF__";
